import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Loading from '../Loading';
import { patchComponent, passAttrs, useAttrsV2 } from '../../_use';
import { withInstall } from '../../_util/component';
const UiIndicatorMoomooDark = patchComponent({
  name: 'UiIndicatorMoomooDark',
  components: {
    Loading
  },
  render() {
    const h = arguments[0];
    const attrs = _objectSpread({}, useAttrsV2(this));
    return h(Loading, _mergeJSXProps([{}, passAttrs(attrs)]));
  }
});
export default withInstall(UiIndicatorMoomooDark);